import HttpClient, { IResponseModel } from "../HttpClient";

import { IDomainFederation } from "@tedivo/tvd-api-models";

const domainFederationsBaseUrl = "domainFederations";

const DomainFederationsService = {
  getAll: async (): Promise<IResponseModel<IDomainFederation[]>> => {
    const client = new HttpClient();
    return await client.request<IDomainFederation[]>({
      method: "GET",
      url: domainFederationsBaseUrl,
    });
  },

  get: async (domain: string): Promise<IResponseModel<IDomainFederation>> => {
    const client = new HttpClient();
    return await client.request<IDomainFederation>({
      method: "GET",
      url: `${domainFederationsBaseUrl}/${domain}`,
    });
  },

  delete: async (domain: string): Promise<IResponseModel<unknown>> => {
    const client = new HttpClient();
    return await client.request<unknown>({
      method: "DELETE",
      url: `${domainFederationsBaseUrl}/${domain}`,
      data: undefined,
    });
  },

  create: async (
    data: IDomainFederation,
  ): Promise<IResponseModel<ICreateOutput>> => {
    const client = new HttpClient();
    return await client.request<ICreateOutput>({
      method: "PUT",
      url: domainFederationsBaseUrl,
      data,
    });
  },

  update: async (
    data: IDomainFederation,
  ): Promise<IResponseModel<ICreateOutput>> => {
    const client = new HttpClient();
    return await client.request<ICreateOutput>({
      method: "PUT",
      url: domainFederationsBaseUrl,
      data,
    });
  },

  ssoCheckDnsTxt: async (
    domain: string,
  ): Promise<IResponseModel<ISSOCheckDnsTxtOutput>> => {
    const client = new HttpClient();
    return await client.request<ISSOCheckDnsTxtOutput>({
      method: "POST",
      url: `${domainFederationsBaseUrl}/check-dns-txt`,
      data: { domain },
    });
  },

  ssoEnableFederation: async (
    data: IDomainFederation,
  ): Promise<IResponseModel<ISimpleResponse>> => {
    const client = new HttpClient();
    return await client.request<ISimpleResponse>({
      method: "POST",
      url: `${domainFederationsBaseUrl}/enable`,
      data: data,
    });
  },

  ssoDisableFederation: async (data: {
    domain: string;
  }): Promise<IResponseModel<ISimpleResponse>> => {
    const client = new HttpClient();
    return await client.request<ISimpleResponse>({
      method: "POST",
      url: `${domainFederationsBaseUrl}/disable`,
      data: data,
    });
  },
};

export default DomainFederationsService;

interface ISimpleResponse {
  id?: string;
}

type ICreateOutput =
  | { id?: string; code?: never; message?: never }
  | ICreateOutputError;

type ICreateOutputError = { id?: never; code: string; message: string };

interface ISSOCheckDnsTxtOutput {
  found: "OK" | "NOT_FOUND" | "WRONG";
}
